import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanDeactivate,
  MaybeAsync,
  GuardResult
} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { DirtyFormProvider } from '@/common/components/form/dirty-form-provider.interface';
import { ConfirmationService } from '@/common/services/confirmation.service';

@Injectable({ providedIn: 'root' })
export class PreventDirtyFormGuard implements CanDeactivate<DirtyFormProvider> {
  constructor(
    private _confirmationService: ConfirmationService,
  ) { }

  canDeactivate(
    component: DirtyFormProvider,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    _nextState: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    if (!component.isDirty()) {
      return true;
    }

    // Check if component provides an override config for the guard dialog
    const overrideConfig = component.getGuardOverrideConfig?.();
    if (overrideConfig) {
      const result$ = new Subject<boolean>();

      this._confirmationService.confirm({
        header: overrideConfig.header,
        message: overrideConfig.message,
        icon: overrideConfig.icon ?? 'pi pi-exclamation-triangle',
        acceptLabel: overrideConfig.acceptLabel,
        rejectLabel: overrideConfig.rejectLabel,
        accept: () => {
          overrideConfig.onAccept?.();
          result$.next(true);
        },
        reject: () => result$.next(false),
      });

      return result$.asObservable() as Observable<GuardResult>;
    }

    const result$ = new Subject<boolean>();

    this._confirmationService.confirm({
      header: 'COMMON.GUARD.FORM_DIRTY_TITLE',
      message: 'COMMON.GUARD.FORM_DIRTY',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'COMMON.GUARD.FORM_DIRTY_ACCEPT',
      rejectLabel: 'COMMON.GUARD.FORM_DIRTY_REJECT',
      accept: () => result$.next(true),
      reject: () => result$.next(false),
    });

    return result$.asObservable() as Observable<GuardResult>;
  }
}
